import React from 'react';
import { Input } from 'antd';
import { Controller } from 'react-hook-form';
import { TextComponent } from 'baseComponents/TextComponent';
import 'baseComponents/InputComponent/inputComponent.scss';
import { NavLink } from 'react-router-dom';

interface Props {
  control: any;
  name: string;
  rules: Record<string, any>;
  type: string;
  labelValue?: string;
  linkLabel?: string;
  linkTo?: string;
  passwordInput?: boolean;
  fullWidth?: boolean;
  textarea?: boolean;
  error?: string;
}

export const ControlledInputComponent: React.FC<Props> = ({
  type = 'text',
  fullWidth,
  ...rest
}) => {
  return (
    <div className={`${fullWidth && 'full-width'}`}>
      <div className='labels-wrapper'>
        {rest.labelValue && (
          <div className='input-wrapper'>
            <TextComponent
              weight='extra-light'
              text={rest.labelValue}
              type='span'
            />
          </div>
        )}
        {rest.linkLabel && (
          <NavLink to={rest.linkTo as string}>
            <div className='input-wrapper'>
              <TextComponent
                weight='extra-light'
                size='small'
                text={rest.linkLabel}
                type='span'
                opacity
              />
            </div>
          </NavLink>
        )}
      </div>
      <Controller
        name={rest.name}
        control={rest.control}
        rules={rest.rules}
        render={({ field }) => (
          <div>
            <Input
              className='input-component'
              bordered={false}
              {...field}
              type={type}
            />
            {rest.error && (
              <TextComponent
                styleType='danger'
                weight='extra-light'
                size='extra-small'
                text={rest.error}
              />
            )}
          </div>
        )}
      />
    </div>
  );
};
